import {
  projectShowTabs,
  projectsIndexTabs
} from "../js-data/project-tab-groups";
import {
  deleteProject,
  getProject,
  getProjects,
  storeProject,
  updateProject
} from "../api-helpers/api-projects";

export default {
  state: {
    isGettingProjects: false,
    isGettingProject: false,
    projects: [],
    project: null,
    isStoringProject: false,
    isUpdatingProject: false,
    isDeletingProject: false,
    indexTabs: projectsIndexTabs,
    showTabs: projectShowTabs
  },
  mutations: {
    setIsGettingProjects(state, bool) {
      state.isGettingProjects = bool;
    },
    setIsGettingProject(state, bool) {
      state.isGettingProject = bool;
    },
    setProjects(state, projects) {
      state.projects = projects;
    },
    setProject(state, project) {
      state.project = project;
    },
    setIsStoringProject(state, bool) {
      state.isStoringProject = bool;
    },
    setIsUpdatingProject(state, bool) {
      state.isUpdatingProject = bool;
    },
    setIsDeletingProject(state, bool) {
      state.isDeletingProject = bool;
    },
    setProjectsIndexTabsCounts(state, counts) {
      state.indexTabs = state.indexTabs.map(tab => {
        tab.count = counts[tab.slug];
        return tab;
      });
    },
    setProjectShowTabsCounts(state, counts) {
      state.showTabs = state.showTabs.map(tab => {
        tab.count = counts[tab.slug];
        return tab;
      });
    }
  },
  actions: {
    async getProjects({ state, commit }, type) {
      let projectsAndCounts;
      if (!state.isGettingProjects) {
        commit("setIsGettingProjects", true);

        projectsAndCounts = await getProjects(type);
        commit("setProjects", projectsAndCounts.projects);
        commit("setProjectsIndexTabsCounts", projectsAndCounts.counts);

        commit("setIsGettingProjects", false);
      }
      return projectsAndCounts;
    },
    async storeProject({ state, commit }, project) {
      let statusAndProject;
      if (!state.isStoringProject) {
        commit("setIsStoringProject", true);

        statusAndProject = await storeProject(project);

        commit("setIsStoringProject", false);
      }
      return statusAndProject;
    },
    async updateProject({ state, rootState, commit, dispatch }, project) {
      let response;
      if (!state.isUpdatingProject) {
        commit("setIsUpdatingProject", true);

        response = await updateProject(project);
        dispatch("handleApiResponse", {
          responseStatus: response,
          successText: "Project updated successfully.",
          errorText: "An error occurred while attempting to update Project.",
          afterSuccessFunction: () => {
            if (project.isShowView) {
              dispatch("getProject", project.id);
            } else {
              if (rootState.Search.areSearchResultsShown) {
                dispatch("searchProjects", rootState.Search.searchTerm);
              } else {
                dispatch("getProjects");
              }
            }
            commit("resetCreateEditComponentParams");
          }
        });

        commit("setIsUpdatingProject", false);
      }
      return response;
    },
    async getProject({ commit, state }, projectId) {
      let projectAndCounts;
      if (!state.isGettingProject) {
        commit("setIsGettingProject", true);

        projectAndCounts = await getProject(projectId);
        commit("setProject", projectAndCounts.project);
        commit("setProjectShowTabsCounts", projectAndCounts.counts);

        commit("setIsGettingProject", false);
      }
      return projectAndCounts;
    },
    async deleteProject({ commit, state }, project) {
      let response;
      if (!state.isDeletingProject) {
        commit("setIsDeletingProject", true);

        response = await deleteProject(project);

        commit("setIsDeletingProject", false);
      }
      return response;
    }
  }
};
